/* eslint-disable no-unused-vars */
import { useIntl } from 'react-intl';
import { Box, Table, TableBody, TableContainer, TableHead, TableRow } from '@mui/material';
import OpenInNewOutlinedIcon from '@mui/icons-material/OpenInNewOutlined';
import type { ApiTrainingItem } from '@agunity/api-v4';

import AgIconButton from '../../stories/AgIconButton';
import { AgColor } from '../../stories/Styles/AgColor';

import { formatDate } from '../../utils';
import * as S from './styled';

type TrainingTable = {
  canEdit?: boolean;
  trainings: ApiTrainingItem[];
  onEdit: (training: ApiTrainingItem) => void;
}

const TrainingTable = ({ trainings = [], onEdit }: TrainingTable) => {
  const messages = useIntl().formatMessage;

  const headers = [{
    field: 'topicName',
    headerName: messages({ id: 'TRAINING_TOPIC_NAME' }),
    width: 165,
  },
  {
    field: 'startSessionDate',
    headerName: messages({ id: 'TRAINING_SESSION_DATE' }),
    width: 114,
  },
  {
    field: 'actions',
    headerName: '',
    width: 114,
  }];

  return (
    <TableContainer>
      <Table sx={{ borderTop: `1px solid ${AgColor.grey4}`, borderLeft: `1px solid ${AgColor.grey4}`, }}>
        <TableHead>
          <TableRow>
            {
              headers?.map((header) => (
                <S.StyledTableCell key={header.field} width={header.width}>{header.headerName || ''}</S.StyledTableCell>
              ))
            }
          </TableRow>
        </TableHead>
        <TableBody>
          {
            trainings?.map((training, index) => (
              <TableRow key={index}>
                <S.StyledTableCell style={{ textAlign: 'left' }}>
                  <Box sx={{ display: 'flex', alignItems: 'center' }}>
                    {training.topicName}
                  </Box>
                </S.StyledTableCell>
                <S.StyledTableCell style={{ textAlign: 'left' }}>{formatDate(training.startSessionDate)}</S.StyledTableCell>
                <S.StyledTableCell isAction>
                  <AgIconButton
                    style={{ display: 'inline-block', margin: '2px' }}
                    buttonStyle={{
                      borderColor: AgColor.grey0,
                      height: 44,
                      width: 44,
                      padding: 0
                    }}
                    onClick={() => onEdit(training)}
                    icon={<OpenInNewOutlinedIcon style={{ color: AgColor.link1, height: 24, width: 24, }} />}
                  />
                </S.StyledTableCell>
              </TableRow>
            ))
          }
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default TrainingTable;